var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0298308 14.7341C-0.223905 10.7792 1.1781 7.66973 2.82535 5.86186C4.47293 4.05394 6.69275 3.19117 9.99309 2.59435C13.2933 1.9972 18.0033 3.07238 20.9878 0C21.4598 19.1045 7.57982 21.8511 0.782479 16.4421C3.15126 13.5896 5.80319 11.5643 9.43227 10.2406C12.0383 9.28978 14.3959 8.81662 16.8196 6.0211C13.2735 8.43138 10.4193 8.60829 8.3098 9.27348C5.17641 10.2619 2.69952 11.5895 0.0299977 14.7342L0.0298308 14.7341Z",
    fill: "#0476ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.bb2e4e4822ea4b4f34d88dbd2a87e17c.svg";
export { ForwardRef as ReactComponent };